/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getFaqs } from "../api";
import {
  scrollToTop,
  tokenSolver,
  privGtmKey,
  makeId,
  getImg,
} from "../utils";
import useCollapse from "react-collapsed";
import { chevron_up, chevron_down, chevron_left, call_center } from "./../pngs";
import { CoalitionSpinner, CoalitionButton, isTokenValid } from "./../components";
import { sendTag, event_properties_105_06 } from "../components/CoalitionGtm";
import "./WildCardPage.scss";

export const FaqsPage = () => {
  const gtm = localStorage.getItem(privGtmKey);
  useEffect(() => {
    if (gtm) sendTag(gtm, event_properties_105_06());
  }, [gtm]);

  const [loading, setLoading] = useState(false);
  const [faqs, setFaqs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isTokenValid()) return navigate("/unauth");
    const fetchData = async () => {
      setLoading(true);
      setFaqs(await getFaqs());
      scrollToTop();
      setLoading(false);
    };
    fetchData();
  }, []);

  return (
    <div className="public-page">
      {loading ? (
        <CoalitionSpinner />
      ) : (
        <PagePrebuilt
          faqs={faqs}
          buttonClicked={() => navigate(`/?${tokenSolver()}`)}
        />
      )}
    </div>
  );
};

const PagePrebuilt = ({ faqs = [], buttonClicked }) => {
  const [content, setContent] = useState([]);

  useEffect(() => {
    const buildFaqs = () => {
      if (!faqs || faqs.length === 0) return;
      const faqsAsHtml = faqs.map((block, k) => (
        <FaqsCard key={k} {...block} />
      ));
      setContent(faqsAsHtml);
    };
    buildFaqs();
  }, [faqs]);

  return (
    <>
      <div className="faqs-page">
        <CoalitionButton
          label="Ayuda"
          klass="nav-button"
          onClickEvent={buttonClicked}
        >
          {getImg(chevron_left, "back-icon")}
        </CoalitionButton>
        <div className="contact-us">
          <span>{getImg(call_center)}</span>
          <label>Comunícate con nosotros al: </label>
          <a href="tel:+525552695000">
            <strong>55 5269 5000</strong>
          </a>
        </div>
        <div className="current-content">{content}</div>
      </div>
    </>
  );
};

const FaqsCard = ({ title, data, id }) => {
  return (
    <div>
      <div className="faq-block-name">{title}</div>
      {data.map(({ question, answer }, idx) => {
        return (
          <FaqRow
            key={makeId(7)}
            question={question}
            answer={answer}
            id={id}
            section={title}
            position={idx + 1}
          />
        );
      })}
    </div>
  );
};

const FaqRow = ({ question, answer, id, section, position }) => {
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();
  useEffect(() => {
    const launchTag = async () => {
      if (!isExpanded) return;
    };
    launchTag();
  }, [id, isExpanded, position, question, section]);
  return (
    <div className="faq-row-container">
      <div className="collapsible">
        <div
          className={`header collapsible-${isExpanded ? "open" : "closed"}`}
          {...getToggleProps()}
        >
          <label>{question}</label>
          {getImg(isExpanded ? chevron_up : chevron_down)}
        </div>
        <div {...getCollapseProps()}>
          <div className="content">{answer}</div>
        </div>
      </div>
    </div>
  );
};
